import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift, CreditCard, ArrowRight } from 'lucide-react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PricingBlock() {
  return <section id="pricing" className="py-10 sm:py-20 px-4" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-20px'
      }} className="bg-green-950/60 backdrop-blur-md rounded-3xl shadow-2xl border-2 border-yellow-300/50 overflow-hidden" data-id="element-162">
          {/* Header Timer — Red pulsing */}
          <motion.div animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="bg-red-600 text-white text-center py-4 px-6" data-id="element-163">
            <span className="font-bold text-sm sm:text-base block mb-2 uppercase" data-id="element-164">
              🔥 El precio de lanzamiento termina en: 🔥
            </span>
            <CountdownTimer className="text-2xl sm:text-3xl text-white" data-id="element-165" />
          </motion.div>

          <div className="bg-red-500/20 text-center py-3 border-b border-white/10" data-id="element-166">
            <span className="text-red-300 font-bold flex items-center justify-center gap-2 text-sm sm:text-base" data-id="element-167">
              Precio promocional por lanzamiento
            </span>
          </div>

          <div className="p-6 sm:p-10" data-id="element-168">
            <div className="text-center mb-8" data-id="element-169">
              <span className="text-4xl mb-4 block" data-id="element-170">📦</span>
              <h2 className="text-2xl sm:text-3xl font-black text-white mb-2 uppercase" data-id="element-171">
                MEGA PACK COMPLETO
              </h2>
              <h3 className="text-xl font-bold text-yellow-300 mb-2 uppercase" data-id="element-172">
                MÉTODO VENTA FLASH IA
              </h3>
              <p className="text-white/80 font-medium" data-id="element-173">
                5 Tomos PDF + 3 Bonos Exclusivos
                <br data-id="element-174" />+ Acceso inmediato
              </p>
            </div>

            <div className="bg-green-900/40 rounded-2xl p-6 mb-8 border border-green-600/20" data-id="element-175">
              <h4 className="font-bold text-white mb-4" data-id="element-176">Lo que recibís:</h4>
              <ul className="space-y-3 mb-6" data-id="element-177">
                {['Tomo 1 — Fundamentos de Venta Rápida', 'Tomo 2 — 50 Prompts de IA', 'Tomo 3 — Sistema Meta Ads', 'Tomo 4 — Diseño Pro con IA', 'Tomo 5 — Cierre de Ventas por WhatsApp'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-178">
                    <CheckCircle2 className="w-5 h-5 text-yellow-300 shrink-0 mt-0.5" data-id="element-179" />
                    <span className="font-medium text-white" data-id="element-180">{item}</span>
                  </li>)}
              </ul>

              <div className="w-full h-px bg-green-600/20 mb-6" data-id="element-181"></div>

              <ul className="space-y-3" data-id="element-182">
                {['Bono 1 — Hoja de Ruta 7 Días', 'Bono 2 — Plantilla Landing Page', 'Bono 3 — Calculadora de Rentabilidad'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-183">
                    <Gift className="w-5 h-5 text-yellow-300 shrink-0 mt-0.5" data-id="element-184" />
                    <span className="font-medium text-white" data-id="element-185">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center mb-8" data-id="element-186">
              <p className="text-lg text-white/70 font-medium mb-1" data-id="element-187">
                Valor real del pack:{' '}
                <span className="line-through text-white/40" data-id="element-188">$64.990</span>
              </p>
              <p className="text-xl font-bold text-white mb-2 uppercase" data-id="element-189">
                💰 PRECIO DE LANZAMIENTO:
              </p>
              <p className="text-6xl sm:text-7xl font-black text-yellow-300 tracking-tight drop-shadow-lg" data-id="element-190">
                $19.990
              </p>
            </div>

            <Button href="https://checkout.guiadigital360.online/cart/44839939866693:1" className="w-full py-5 text-xl sm:text-2xl mb-6 shadow-xl" data-id="element-191">
              QUIERO MI MEGA PACK AHORA ⚡
            </Button>

            <div className="flex justify-center mb-6" data-id="element-192">
              <img src="https://cdn.magicpatterns.com/uploads/1NjAXL8VD4jxsxMBHnwqHB/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="w-28 sm:w-32 h-auto drop-shadow-lg" width={128} height={128} loading="lazy" decoding="async" data-id="element-193" />
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-194">
              <div className="flex flex-wrap justify-center items-center gap-4 text-sm font-bold text-white/80 uppercase" data-id="element-195">
                <span data-id="element-196">🔒 Pago seguro</span>
                <span className="hidden sm:inline" data-id="element-197">·</span>
                <span data-id="element-198">⚡ Acceso inmediato</span>
                <span className="hidden sm:inline" data-id="element-199">·</span>
                <span data-id="element-200">✅ Garantía 7 días</span>
              </div>

              <div className="flex items-center gap-2 text-sm text-white/70 bg-green-900/30 px-4 py-2 rounded-lg border border-green-600/20" data-id="element-201">
                <CreditCard className="w-4 h-4" data-id="element-202" />
                <span data-id="element-203">
                  Transferencia · Mercado Pago · Tarjeta de crédito/débito
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}